import React from 'react';

import Image from '../AppImage';

const ProgressTracker = ({ 
  currentQuestion = 1, 
  totalQuestions = 25, 
  currentScreen = 'landing',
  completionPercentage = 0 
}) => {
  const getProgressData = () => {
    switch (currentScreen) {
      case 'landing':
        return { percentage: 0, label: 'Ready to Begin' };
      case 'question-assessment':
        return { 
          percentage: (currentQuestion / totalQuestions) * 100, 
          label: `Question ${currentQuestion} of ${totalQuestions}` 
        };
      case 'email-capture':
        return { percentage: 95, label: 'Almost Complete' };
      case 'personalized-results':
        return { percentage: 100, label: 'Assessment Complete' };
      default:
        return { percentage: 0, label: 'Getting Started' };
    }
  };

  const { percentage, label } = getProgressData();

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50 bg-brand-black/95 backdrop-blur-sm border-b border-brand-slate hidden md:block">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-3">
          <div className="flex items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <Image
                src="/assets/images/FullLogo_Transparent_White-1768328997474.png"
                alt="Limitless Men logo in white"
                className="h-10 w-auto"
                loading="eager"
                width="200"
                height="40"
              />
            </div>
            
            <div className="flex-1 max-w-md">
              <div className="bg-brand-charcoal rounded-full h-2 overflow-hidden mb-2">
                <div 
                  className="h-full bg-brand-gold rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                  role="progressbar"
                  aria-valuenow={percentage}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  aria-label={`Assessment progress: ${Math.round(percentage)}%`}
                />
              </div>
              <span className="text-sm text-brand-steel font-semibold uppercase tracking-wide">{label}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed top-0 left-0 right-0 z-50 bg-brand-black/95 backdrop-blur-sm border-b border-brand-slate md:hidden">
        <div className="px-4 py-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Image
                src="/assets/images/FullLogo_Transparent_White-1768328997474.png"
                alt="Limitless Men logo"
                className="h-7 w-auto"
                loading="eager"
                width="200"
                height="40"
              />
            </div>

            <div className="flex items-center gap-3">
              <div className="relative w-10 h-10">
                <svg className="w-10 h-10 transform -rotate-90" viewBox="0 0 64 64">
                  <circle
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke="#2D2D2D"
                    strokeWidth="4"
                  />
                </svg>
                <svg 
                  className="absolute top-0 left-0 w-10 h-10 transform -rotate-90"
                  viewBox="0 0 64 64"
                >
                  <circle
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke="#C9A227"
                    strokeWidth="4"
                    strokeDasharray={`${(percentage / 100) * 175.93} 175.93`}
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center text-xs font-bold text-brand-gold">
                  {Math.round(percentage)}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgressTracker;